import { useTranslation } from 'react-i18next'

const TailwindButton = ({
  text = "Save & Continue",
  type = "button",
  disabled = false,
  onClick = () => {},
  formId = "",
  variant = "primary", // "primary" | "danger"
  outline = false,
  className = "tailwind-button",
  children = null,
  danger,
  ...rest
}) => {
  const { t } = useTranslation()

  const baseStyle = "px-3 py-1.5  text-sm transition rounded"

  const getVariantClass = () => {
    if (variant === "primary") {
      return outline
        ? "text-green-600 border border-green-600 hover:bg-green-600 hover:text-white"
        : "bg-green-600 text-white hover:bg-green-700 border border-green-600"
    }

    if (variant === "danger") {
      return outline
        ? "text-red-600 border border-red-600 hover:bg-red-600 hover:text-white"
        : "bg-red-600 text-white hover:bg-red-700 border border-red-600"
    }

    if (variant === "default") {
      return outline
      ? "text-blue-500 border border-blue-500 hover:bg-blue-400 hover:text-white"
      : "bg-blue-500 text-white hover:bg-blue-400 border border-blue-500"
    }
    return "" // default fallback
  }

  const disabledStyle = disabled ? " opacity-50 cursor-not-allowed" : ""

  const buttonClass = `${baseStyle} ${getVariantClass()}${disabledStyle}`

  return (
    <button
      className={`${buttonClass} ${className}`}
      onClick={onClick}
      disabled={disabled}
      type={type}
      form={formId}
      {...rest}
    >
      {children || t(text)}
    </button>
  )
}

export default TailwindButton
